import { createContext, useContext } from 'react';

/**
 * Whether the tab panel around you is the one on screen.
 *
 * Hidden panels stay mounted under `display: none`, where everything inside measures
 * zero. Most content does not care. A data grid does: it resolves its flex columns
 * against that zero and keeps the answer, so the table comes back with its columns
 * collapsed. Content that lays itself out can read this and render nothing until it
 * has real width to work with.
 *
 * Defaults to visible, so a component rendered outside a tab panel behaves normally.
 */
const PanelVisibilityContext = createContext(true);

export const PanelVisibilityProvider = PanelVisibilityContext.Provider;

export const useIsPanelVisible = (): boolean => useContext(PanelVisibilityContext);
